import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/depop-shipping';

export default function Example() {
  return (
    <>
      <Head>
        <title>Depop Shipping 2022 - The Simple Guide to Depop Shipping your Sales</title>
        <meta
          name='description'
          content="Depop is a social media platform for buying and selling second-hand items. The company offers sellers the option to choose their own shipping costs. However, this can lead to many mistakes in pricing, which will hurt your business and discourage buyers from purchasing from you. This article will break down the basics of Depop's shipping costs for sellers, shipping and packaging fees, and how to set your price right!"
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/depop-shipping-2021' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/depop-shipping-2021' />
        <meta property='og:title' content='Depop Shipping 2022 - The Simple Guide to Depop Shipping your Sales' />
        <meta
          property='og:description'
          content="Depop is a social media platform for buying and selling second-hand items. The company offers sellers the option to choose their own shipping costs. However, this can lead to many mistakes in pricing, which will hurt your business and discourage buyers from purchasing from you. This article will break down the basics of Depop's shipping costs for sellers, shipping and packaging fees, and how to set your price right!"
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
